module.exports = "/virtual-football/img/video/vvb-header.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/video/vvb-header.png
// module id = 316
// module chunks = 6